import { createSelectorFunctions } from 'auto-zustand-selectors-hook';
import { create } from 'zustand';
import type { RouteProps } from '../routes/utils/deriveRouteProps';

interface Palette {
  isLoading?: boolean;
  error?: Error;
  hex?: string;
  vibrant?: string;
}

export interface AppState {
  guideItemPathname: string;
  hasAdBlocker: boolean;
  guideItemPalettes: Record<string, Palette>;
  /** For code outside React; components read `useRouteProps()` instead. */
  routeProps: RouteProps | null;
}

export interface AppActions {
  setGuideItemPathname: (guideId: string) => void;
  setHasAdBlocker: (hasAdBlocker: boolean) => void;
  setGuideItemPalette: (guideId: string, palette: Palette) => void;
  setRouteProps: (routeProps: RouteProps) => void;
}

export type AppStore = AppState & AppActions;
export type InitialAppState = Partial<AppState>;

const defaultState: AppState = {
  guideItemPathname: '',
  hasAdBlocker: false,
  guideItemPalettes: {},
  routeProps: null,
};

export function createAppStore(initialState: InitialAppState = {}) {
  const appStore = create<AppStore>((set) => ({
    ...defaultState,
    ...initialState,

    setGuideItemPathname: (guideItemPathname: string) => set({ guideItemPathname }),
    setHasAdBlocker: (hasAdBlocker: boolean) => set({ hasAdBlocker }),
    setRouteProps: (routeProps) => set({ routeProps }),

    setGuideItemPalette: (guideId, palette) =>
      set((state) => ({
        guideItemPalettes: {
          ...state.guideItemPalettes,
          [guideId]: palette,
        },
      })),
  }));

  return createSelectorFunctions(appStore);
}
